import React            from "react";
import PropTypes        from "prop-types";

import {Checkbox} from "@material-ui/core";

const CheckboxAtm = props => (
    <Checkbox
        type="checkbox"
        className={props.className}
        id={props.checkboxId}
        value={props.value}
        onChange={props.onChange}
        checked={props.checked}
        defaultChecked={props.defaultChecked}
        name={props.name}
        disabled={props.disabled}
    >
        {props.factName}
    </Checkbox>
);

CheckboxAtm.propType = {
    name: PropTypes.name,
    checkboxId: PropTypes.any,
    checked: PropTypes.any,
    defaultChecked: PropTypes.any,
    disabled: PropTypes.any,
    control: PropTypes.any,
    onChange: PropTypes.func,
    factName: PropTypes.any,
    color: PropTypes.string,
    labelPlacement: PropTypes.string,
    value: PropTypes.string,

};

export default CheckboxAtm;
